import styled, { css } from 'styled-components'

export const PageUnavailableWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin: 0 auto;
    padding: ${theme.spacing.inset['lg']} ${theme.spacing.inset['2xl']};
    max-width: 1440px;
  `}
`

export const MessageBody = styled.div`
  ${({ theme }) => css`
    p {
      text-align: center;
      font-size: ${theme.font.size['xl']};
      color: ${theme.color.brandPrimary.medium};

      ${theme.breakpoint['lg']} {
        font-size: ${theme.font.size['3xl']};
      }
    }
  `}
`